import { RequestBuilderService } from '@klickdata/core/http';
import { ConfigService } from '@klickdata/core/config';
import { Injectable } from '@angular/core';
import { ScormData, Scorm } from './scorm.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Media } from '@klickdata/core/media/src/media.model';

@Injectable({
    providedIn: 'root',
})
export class ScormService {
    protected scormUrl: string;
    constructor(protected configService: ConfigService, protected builder: RequestBuilderService) {
        this.scormUrl = `${configService.config.resourceUrl}scorm`;
    }

    public getScormByResId(resId: number): Observable<Scorm> {
        const request = this.builder.get(`${this.scormUrl}`);
        request.param('resource', resId);
        return request.request().pipe(map((res) => this.mapScorm(res.data)));
    }

    public getScormById(id: number): Observable<Scorm> {
        return this.builder
            .get(`${this.scormUrl}/${id}`)
            .request()
            .pipe(map((res) => this.mapScorm(res.data)));
    }

    public saveFromUri(media: Media): Observable<Scorm> {
        return this.builder
            .post<ScormData>(`${this.scormUrl}?uri=${media.path}/${media.filename}`, null)
            .request()
            .pipe(map((res) => this.mapScorm(res.data)));
    }

    public uploadScorm(file: File): Observable<Scorm> {
        const data: FormData = new FormData();
        data.append('file', file);
        return this.builder
            .post<ScormData>(`${this.scormUrl}`, data)
            .request()
            .pipe(map((res) => this.mapScorm(res.data)));
    }

    protected mapScorm(scormData: ScormData): Scorm {
        return new Scorm(scormData);
    }
}
